<template lang="pug">
  y-dialog(v-model="showModal" fill-height fluid scrollable persistent transition="fade-transition" max-width="600px")
    v-card
      v-card-title.pa-4
        div.h6.basic800--text {{ $t('edit_page_link') }}
      v-card-text.px-4.py-0
        v-layout.my-6(v-if="isFetching")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
        template(v-else)
          div.s1.primary--text {{ $t('custom_link') }}
          div.p2.basic700--text.mt-1 {{ $t('custom_link_desc') }}
          v-form(ref="form")
            v-text-field.my-2(v-model='customLink' background-color="basic200" height="40" outlined dense persistent-hint counter placeholder="custom_link" :prefix="`https://${this.company.slug}.yezza.io/`" :maxlength="50")
      v-card-actions
        v-spacer
        v-btn(color='white', text @click="showModal = false")
          .button-Aa-small.primary400--text {{ $t('cancel') }}
        v-btn.mr-2.button-AA-small(color='info500' depressed height=32 @click="clickSave" :loading="isLoading" dark) {{ $t('save') }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import LandingFormType from '@/components/localads/LandingFormType.vue'

export default {
  name: 'EditLandingPageLink',
  props: ['open', 'parentForm', 'company'],
  components: { LandingFormType },
  data: () => ({
    isFetching: false,
    isLoading: false,
    customLink: null,
    customLinkId: null,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required']
    },
  }),
  computed: {
    ...mapState('user', ['member']),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    form: {
      get() {
        return this.parentForm
      },
      set(newValue) {
        this.$emit('update:parentForm', newValue)
      }
    },
  },
  mounted () {
    this.fetchCustomLink()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchCustomLink () {
      this.isFetching = true
      let url = this.member.role === 'Agent' ? `member=${this.member.id}` : 'without_member=true'
      this.$axios.get(`/forms/${this.form.id}/slugs/?${url}`)
        .then(resp => {
          if (resp.data.results.length > 0) {
            this.customLink = resp.data.results[0].slug
            this.customLinkId = resp.data.results[0].id
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    clickSave () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      if (this.customLink) {
        if (this.customLinkId) {
          this.axios.patch(`/forms/${this.form.id}/slugs/${this.customLinkId}/`, { slug: this.customLink })
            .then(() => {
              this.showMessage(['success', this.$t('success_message.form_updated')])
              this.$emit('updated')
              this.showModal = false
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_update_custom_link')])
            })
            .finally(() => {
              this.isLoading = false
            })
        } else {
          let data = {
            slug: this.customLink,
          }
          if (this.member.role === 'Agent') {
            data['member'] = this.member.id
          }
          this.axios.post(`/forms/${this.form.id}/slugs/`, data)
            .then(() => {
              this.showMessage(['success', this.$t('success_message.form_updated')])
              this.$emit('updated')
              this.showModal = false
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_update_custom_link')])
            })
            .finally(() => {
              this.isLoading = false
            })
        }
      } else {
        if (this.customLinkId) {
          this.axios.delete(`/forms/${this.form.id}/slugs/${this.customLinkId}`)
            .then(() => {
              this.showMessage(['success', this.$t('success_message.form_updated')])
              this.$emit('updated')
              this.showModal = false
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_update_custom_link')])
            })
            .finally(() => {
              this.isLoading = false
            })
        } else {
          this.showMessage(['success', this.$t('success_message.form_updated')])
          this.showModal = false
        }
      }
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "edit_page_link": "Edit page link",
    "custom_link": "Custom link",
    "custom_link_desc": "The page URL will appear as below"
  },
  "id": {
    "edit_page_link": "Edit halaman link",
    "custom_link": "link khusus",
    "custom_link_desc": "URL halaman ini akan muncul seperti di bawah"
  }
}
</i18n>
